import React from "react";
import { observer } from "mobx-react";
import { MediaItemDetailsScreen } from "../../resources/MediaItemDetailsScreen";

export const AssignmentResourceDetailsScreen: React.FC<any> = observer(
  (props) => <MediaItemDetailsScreen />
);
